import {Remedy} from "../../rest/Remedy";
import {AlertComment} from "../../rest/AlertComment";
import {AlertStatus} from "./AlertStatus";

export class AlertData {

  line = '--';
  lineId = '--';
  asset: string | undefined;
  assetId: string | undefined;
  assetDisplayName: string | undefined;
  client: string | undefined;
  clientId: number | undefined;
  plant: string | undefined;
  room: string | undefined;
  userName?: string;
  source = '--';
  assetTypeTemplateTag: string | undefined;

  name: string | undefined;
  description: string | undefined | null;
  title: string | undefined | null;
  conditions: string | undefined;
  openDatetime: string | undefined;
  openDuration: string | undefined;
  openDatetimeMillis: number | undefined; // Used for sorting and comparison purposes
  closeDatetime: string | undefined;
  closeDatetimeMillis: number | undefined;
  ackDatetime: string | undefined;
  ackDatetimeMillis: number | undefined;
  status: AlertStatus | undefined;
  ackDuration: string | undefined;
  closeDuration: string | undefined;
  ackUserLogoUrl?: string;
  ackUserAvatar?: string;
  ackUserFirstName?:string;
  ackUserLastName?:string;
  ackUserIsSee?:boolean;
  ackUserRoles?:Array<string>;
  ackBy: string | undefined;
  ackComment: string | undefined;

  availableTo: string | undefined;
  childAnomalies: string | undefined;

  alertRuleId: string | undefined;
  alertInstanceId: string | undefined;
  currentFeedback: string | undefined;
  alertRuleType: string | undefined;
  remedy: Remedy | undefined;
  commentList?: Array<AlertComment> =  [];

  type = 'Alert';

  isRealAlert = true; // Used to display alert not found message.

  populateSource() {
    this.source = this.assetDisplayName!;

    if (!this.source || this.source.length === 0) {
      this.source = '--';
    }
  }
}
